var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.index+'article_home',staticClass:"baseFormBox"},[_c('div',{key:_vm.index+'article_box',staticClass:"article_html",domProps:{"innerHTML":_vm._s(_vm.options.value)}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }